module.exports = __webpack_public_path__ + "static/media/bin.099a5a6d.svg";